import {
  SET_ANALYSIS_IS_PROCESSING,
  SET_ANALYSIS_PROCESSING_STEP,
  SET_ANALYSIS_ACTIVE_LAYER,
  SET_ANALYSIS_LAYERS,
  SET_ANALYSIS_LAYERS_SORTING,
  SET_ANALYSIS_VISIBLE_LAYERS,
  SET_PROJECT_EXPORTS
} from './consts';

export const setProjectAnalysisLayers = layers => {
  return {
    type: SET_ANALYSIS_LAYERS,
    layers
  };
};

export const setProjectAnalysisIsProcessing = isProcessing => {
  return {
    type: SET_ANALYSIS_IS_PROCESSING,
    isProcessing
  };
};

export const setProjectAnalysisProcessingStep = processingStep => {
  return {
    type: SET_ANALYSIS_PROCESSING_STEP,
    processingStep
  };
};

export const setProjectAnalysisActiveLayerId = activeLayerId => {
  return {
    type: SET_ANALYSIS_ACTIVE_LAYER,
    activeLayerId
  };
};

export const setProjectAnalysisVisibleLayerIds = visibleLayerIds => {
  return {
    type: SET_ANALYSIS_VISIBLE_LAYERS,
    visibleLayerIds
  };
};

export const setProjectAnalysisLayersSorting = layersSorting => {
  return {
    type: SET_ANALYSIS_LAYERS_SORTING,
    layersSorting
  };
};

export const setProjectExports = exports => {
  return {
    type: SET_PROJECT_EXPORTS,
    exports
  };
};



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/layersActions.js